module.exports = __webpack_public_path__ + "img/website.063eacdf.png";